/**
 * Created by bing on 2018/3/30.
 */
module.exports = function (Vue) {
  let that = new Vue()
  let resourceUrl = that.globalData.resourceUrl

  Vue.prototype.$getCookie = function (key) {
    let name = key + "="
    let ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1)
      if (c.indexOf(name) != -1) return JSON.parse(c.substring(name.length, c.length))
    }
    return ''
  }
  Vue.prototype.$setCookie = function (key, value, exdays) {
    let d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    let expires = "expires=" + d.toUTCString()
    console.info(key + "=" + value + "; " + expires)
    document.cookie = key + "=" + value + "; " + expires
  }
  Vue.prototype.$export = function (url) {
    var form = $("<form>");
    form.attr("style","display:none");
    form.attr("target","");
    form.attr("method","get");
    form.attr("action",resourceUrl + url);
    var input1 = $("<input>");
    input1.attr("type","hidden");
    $("body").append(form);
    form.append(input1);
    form.submit();
    form.remove();
  }
  Vue.prototype.$contentToUrl = function (options,success,error) {
    let con = '<!DOCTYPE html PUBLIC "-//WAPFORUM//DTD XHTML Mobile 1.0//EN" "http://www.wapforum.org/DTD/xhtml-mobile10.dtd"><html xmlns="http://www.w3.org/1999/xhtml"><head><meta charset="UTF-8"></head><body>'+(options.content || '')+'</body></html>'
    let html = new Blob([con], {type : 'text/html'});
    let fileName = options.fileName || new Date().getTime() + '.html'
    let url = options.host || this.globalData.uploadHost
    this.$http$({method:'get',url:'/webServer/oss/sigle',data:{type:options.type},backDirect:true},(data) => {
      let params ={
        'key' :data.dir+'/' +fileName,
        'policy': data.policy,
        'OSSAccessKeyId': data.accessid,
        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
        'signature': data.signature,
        'file': html,
      }
      let fd = new FormData
      for(var i in params){
        fd.append(i,params[i])
      }
      this.$http$({method:'post',url:url,data:fd,dirUrl:true,backDirect:true}, (data) => {
        success(params.key)
      },() => {error()})
    })
  }
  Vue.prototype.$mapList = function (data,callback) {
    for(var i =0;i< data.length;i++){
      callback(data[i].id,data[i].name)
    }
  }
  Vue.prototype.$mapTree = function(data,childChar,callback){
    callback(data.id,data.name)
    if(data[childChar]&&data[childChar].length){
      var i = 0;
      for (i = 0; i < data[childChar].length; i++) {
          this.$mapTree(data[childChar][i],childChar,callback);
      }
    }
  }
  Vue.prototype.$checkLogin = function () {
    let LoginUser = that.$getCookie('METER_LOGIN_USER')
    if(LoginUser){
      return LoginUser
    }else{

      window.location.href = 'login.html'
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/common.js